module.exports = __webpack_public_path__ + "img/1ae7ffb.png";